'use client';

/**
 * SplitCause layout that tracks tool usage
 */

import { useEffect } from 'react';
import { trackToolUsage } from '@/components/RecentlyUsedTools';

export default function SplitCauseLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  // Track splitcause usage
  useEffect(() => {
    trackToolUsage('/splitcause');
  }, []);

  return <>{children}</>;
}
